<template>
  <el-dialog
    :visible.sync="visible"
    title="导出"
    width="60%"
    @open="handleOpen"
    :before-close="handleClose"
  >
    <el-row :gutter="10" style="padding-bottom: 10px">
      <el-col :span="1">
        <el-dropdown>
          <el-button type="primary" size="small">导出数据</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="exportHistory"
              >导出聊天记录</el-dropdown-item
            >
            <el-dropdown-item @click.native="exportUserProfile"
              >导出用户画像</el-dropdown-item
            >
            <el-dropdown-item @click.native="exportUserChat"
              >导出用户会话</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <el-table
      :data="this.cicadeStore?.chats"
      border
      height="500"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="chatId" label="会话ID" />
      <el-table-column prop="title" label="名称">
        <template #default="scope">
          {{ scope.row.title || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="attentionPoint" label="是否标记">
        <template #default="scope">
          <el-tag :type="scope.row.attentionPoint ? 'success' : 'warning'">{{
            scope.row.attentionPoint ? "是" : "否"
          }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import * as XLSX from "xlsx";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chatId: [],
    };
  },
  computed: {
    ...mapState(["cicadeStore"]),
  },
  methods: {
    handleOpen() {
      console.log(this.cicadeStore.chats);
    },
    handleClose() {
      this.$emit("close");
    },
    handleSelectionChange(e) {
      let arr = e;
      this.chatId = arr.map((item) => item.chatId);
      console.log(this.chatId);
    },
    exportHistory() {
      if (this.chatId.length <= 0) {
        this.$message.error("请选择会话");
        return;
      }
      this.$http({
        url: "/client/exportChatHistory",
        method: "post",
        responseType: "blob",
        data: {
          type: "chat",
          account: this.cicadeStore.activeAccount.account,
          channelName: this.cicadeStore.activeAccount.channelName,
          chatIds: this.chatId,
        },
      }).then((messages) => {
        const blob = new Blob([messages]);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "聊天记录.xlsx";
        link.click();
        URL.revokeObjectURL(url);
      });
    },
    exportUserProfile() {
      if (this.chatId.length <= 0) {
        this.$message.error("请选择会话");
        return;
      }
      this.$http({
        url: "/client/exportChatHistory",
        method: "post",
        responseType: "blob",
        data: {
          type: "portrait",
          account: this.cicadeStore.activeAccount.account,
          channelName: this.cicadeStore.activeAccount.channelName,
          chatIds: this.chatId,
        },
      }).then((messages) => {
        const blob = new Blob([messages]);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "用户画像.xlsx";
        link.click();
        URL.revokeObjectURL(url);
      });
    },
    exportUserChat() {
      if (this.chatId.length <= 0) {
        this.$message.error("请选择会话");
        return;
      }
      console.log(this.chatId);
      const selectedData = this.cicadeStore.chats.filter((chat) =>
        this.chatId.includes(chat.chatId)
      );
      const worksheet = XLSX.utils.json_to_sheet(selectedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "用户会话");
      XLSX.writeFile(workbook, "用户会话.xlsx");
    },
  },
};
</script>
<style lang="scss" scoped></style>
